import { DEFAULT_LOCALE_ID, LocaleId } from '@sans-souci/configs'

export const coalesceLocaleField = (
  fieldName: string,
  localeId: LocaleId,
  defaultLocaleId = DEFAULT_LOCALE_ID,
) =>
  `"${fieldName}": coalesce(${fieldName}.${localeId}, ${fieldName}.${defaultLocaleId})`
